import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

import EmailIcon from '../../assets/icons/Emails, Letter, Mail.png';
import FacebookIcon from '../../assets/icons/Facebook.png';
import AppleIcon from '../../assets/icons/Apple.png';
import AuthWrapper from '../../common/AuthWrapper';
import CustomSocialMediaButton from '../../common/CustomSocialMediaButton';
import { useIsMobile } from '../../hooks/useWindowWidth';
import GoogleButton from '../../common/GoogleButton/GoogleButton';

import styles from './SignUp.module.scss';

const SignUp: FC = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
  <AuthWrapper btnName='Sign In'>
    <Box className={styles.signUpContent}>
      <Typography variant={`${isMobile ? 'h6Bold' : 'h5Bold'}`} className={styles.title}>Sign Up</Typography>
      <CustomSocialMediaButton
        customStyle={styles.emailButton}
        text='Continue with Email'
        icon={EmailIcon}
        onClick={() => navigate('/create-account')}
      />
      <Box className={styles.signUpText}>
        <Box className={styles.dividerLine}></Box>
        <Typography variant='h12' className={styles.dividerText} >OR</Typography>
        <Box className={styles.dividerLine}></Box>
      </Box>
      <Box className={styles.socialMediaButtons}>
        <CustomSocialMediaButton
          customStyle={styles.socialMediaButton}
          text='Continue with Facebook'
          icon={FacebookIcon}
          onClick={() => console.log('Continue with Facebook')}
        />
        <GoogleButton />
        <CustomSocialMediaButton
          customStyle={styles.socialMediaButton}
          text='Continue with Apple'
          icon={AppleIcon}
          onClick={() => console.log('Continue with Apple')}
        />
      </Box>
      <Box className={styles.signInQuestion}>
        <Typography variant='h11' className={styles.signInQuestionText}>Already have an account?</Typography>
        <Link to='/' className={styles.signInLink}>
          <Typography variant='h11Semibold'>Log In</Typography>
        </Link>
      </Box>
      <Box className={styles.termsAndConditions}>
        <Typography variant='h11' sx={{textAlign: 'center'}}>By signing up, you understand and agree with TravGenius'</Typography>
        <Typography variant='h11'>
          <Link to='/'>Terms & Conditions</Link> and <Link to='/'>Privacy Policy</Link>
        </Typography>
      </Box>
    </Box>
  </AuthWrapper>
)};

export default SignUp;
